import { ArrowRight, Sparkles } from "lucide-react";
import { useAdvisor } from "@/advisor/AdvisorContext";
import { track, trackOpen } from "@/advisor/api";
import AdvisorLoop from "@/advisor/AdvisorLoop";


export default function AdvisorStrip() {
  const { setDrawer } = useAdvisor();
  const open = () => {
    if (!sessionStorage.getItem("lm_started")) {
      sessionStorage.setItem("lm_started", "1");
      track("started");
    }
    trackOpen("strip");
    setDrawer(true);
  };

  return (
    <section id="advisor" className="-mt-10 md:-mt-14 pb-6 md:pb-8 scroll-mt-24" data-testid="advisor-home-strip">
      <div className="container-lm">
        <button
          onClick={open}
          data-testid="advisor-strip-open"
          className="group adv-stage w-full text-left rounded-[24px] border border-[#D6AD62]/30 px-5 py-6 sm:px-8 sm:py-7 flex flex-col lg:flex-row lg:items-center gap-5 lg:gap-6 transition-[transform,box-shadow] duration-300 hover:-translate-y-0.5 hover:shadow-[0_24px_50px_-28px_rgba(23,23,21,.7)]"
        >
          <span className="relative h-12 w-12 shrink-0 rounded-2xl bg-[#D6AD62] text-[#171715] grid place-items-center">
            <Sparkles size={22} />
          </span>
          <span className="relative flex-1 min-w-0">
            <span className="adv-eyebrow">Business Advisor · Yeni</span>
            <span className="block font-display text-xl sm:text-2xl lg:text-[22px] xl:text-2xl font-semibold text-[#F3EEE4] mt-1.5 leading-snug">
              Biznesiniz üçün də belə həll istəyirsiniz? <span className="text-[#D6AD62] whitespace-nowrap">1 dəqiqəyə tapaq.</span>
            </span>
          </span>
          <AdvisorLoop />
          <span className="relative adv-btn shrink-0 w-full lg:w-auto">
            Həll tap <ArrowRight size={18} className="transition-transform group-hover:translate-x-1" />
          </span>
        </button>
        <p className="text-center text-xs text-[#77736B] mt-2">Pulsuz • Qeydiyyat tələb olunmur</p>
      </div>
    </section>
  );
}
